import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ImpiantiClienteActions";
import { ImpiantoLight } from "../generated";

class ImpiantiClienteStore extends AbstractLookupStore<ImpiantoLight> {
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getForCustomer, result => this.set(result.idCliente.toString(), result.impianti))
    }

    public useForCustomer = (idCliente: number) => this.useStoreWithAction(idCliente.toString(), key => Actions.getForCustomer(+key));
    public use = (idCliente: number, id: number) => this.useForCustomer(idCliente)?.find(i => i.id == id);
}

export default new ImpiantiClienteStore()
